module.exports = __webpack_public_path__ + "prod/20260407184439/img/service.edbff227.png";